import { ReactTooltipStyled } from "components/atoms/Tooltip/Tooltip.styled";
import { Small } from "utils/styling/typography.styled";
export const DescriptionTooltip = () => {
  return <ReactTooltipStyled id="descriptionTip" data-sentry-element="ReactTooltipStyled" data-sentry-component="DescriptionTooltip" data-sentry-source-file="index.tsx">
            <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">
                Use the &quot;Additional Information&quot; box to enhance your
                prompt
            </Small>
            <ul>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">Extra keywords</Small>
                </li>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">Specific values</Small>
                </li>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">Scene settings</Small>
                </li>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">Character poses</Small>
                </li>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">Background elements</Small>
                </li>
            </ul>
            <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">Available for Subscribers or with Premium Mode.</Small>
        </ReactTooltipStyled>;
};